import { TRootState } from '../@types/redux'

export const selectToken = (state: TRootState) => state.auth.token

export const selectUser = (state: TRootState) => state.auth.user

export const selectIsAuth = (state: TRootState) => state.auth.isAuth
